import { Loader } from "@googlemaps/js-api-loader";

export const googleLoader = new Loader({
  apiKey: process.env.REACT_APP_GOOGLE_KEY || "",
  libraries: ['geometry', 'places'],
  version: "weekly"
});